import { Drive } from '../Workspaces/types';
import { DriveItem, DriveType } from './types';

export const getDriveTypeFromName = (
  drive: DriveItem | Drive
): DriveType | undefined => {
  if (!drive.id || !drive.name) return;
  /**
   * To handle share drive, we force the drive.id to be 'shared'
   * See web/browser/pages/dashboard/workspaces/[workspaceId].tsx
   */
  if (drive.id.toLowerCase() === 'shared') return DriveType.Shared;
  switch (drive.name.toLowerCase()) {
    case DriveType.Team.toLowerCase():
      return DriveType.Team;
    case DriveType.Personal.toLowerCase():
      return DriveType.Personal;
    default:
      return DriveType.Custom;
  }
};

export default {
  getDriveTypeFromName,
};
